<template>
  <div>
    <b-row class="mx-md-0 mt-3">
      <b-col cols="12" md="4" class="mb-3">
        <Button
          :click="handleSendSmsModal"
          variant="outline-primary"
          btnClass="font_20"
          iconName="send-outline"
          iconClass="rotate_svg_180"
          :title="$lang.ticketLang.send_ticket_message"
        />
      </b-col>
      <b-col cols="12" md="4" class="mb-3">
        <Button
          :click="handleChangeUnitModal"
          variant="outline-primary"
          btnClass="font_20"
          iconName="account-arrow-left-outline"
          :title="$lang.ticketLang.move_to_other_unit"
        />
      </b-col>
      <b-col cols="12" md="4" class="mb-3">
        <Button
          :click="handleTagsModal"
          variant="outline-primary"
          btnClass="font_20"
          iconName="tag-multiple-outline"
          :title="$lang.ticketLang.edit_tags"
        />
      </b-col>
    </b-row>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="showModal"
      size="md"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <div v-text="modalTitle" />
        </div>
        <b-overlay :show="loading">
          <b-row v-if="modalMode === 'SEND_MESSAGE'">
            <b-col cols="12">
              <b-form-group
                :label="$lang.ticketLang.message_sms"
                label-for="message_description"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.ticketLang.message_sms"
                  :rules="$v.form.message_description.$params"
                />
                <b-form-textarea
                  data-testid="message_description"
                  type="text"
                  name="message_description"
                  autocomplete="off"
                  :state="
                    $v.form.message_description.$dirty
                      ? !$v.form.message_description.$error
                      : null
                  "
                  v-model="$v.form.message_description.$model"
                ></b-form-textarea>
                <b-form-invalid-feedback id="name-feedback"
                  >{{
                    $lang.ticketLang.error_required
                      | replace($lang.ticketLang.message_sms)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="modalMode === 'TARGET_UNIT'">
            <b-col cols="12">
              <b-form-group
                :label="$lang.ticketLang.target_unit_all"
                label-for="target_unit_all"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.ticketLang.target_unit_all"
                  :rules="$v.form.ticket_unit_selected.$params"
                  :showInfo="true"
                  :titleText="``"
                />
                <selectFind
                  :options="ticket_unit_options"
                  v-model="$v.form.ticket_unit_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.form.ticket_unit_selected.$dirty
                      ? !$v.form.ticket_unit_selected.$error
                      : null
                  "
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.form.ticket_unit_selected.$error
                      ? 'block'
                      : 'none',
                  }"
                  id="ticket_unit_selected_feedback"
                >
                  {{
                    $lang.ticketLang.error_required
                      | replace($lang.ticketLang.ticket_page.unit)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="modalMode === 'SHOW_TAGS'">
            <b-col cols="12" md="12">
              <TagComponent
                category_name="tag_ticket"
                :label="$lang.tags"
                :multiple="true"
                :parentPermissions="['admin', 'edit']"
                :parentValue="form.tag_selected"
                :requiredLabel="tagInputRequired"
                :checkValidation="tagCheckValidation"
                @updateCheckValidation="tagUpdateCheckValidation"
                @getSelected="getSelected"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="text-right pt-3">
              <b-button
                @click="handleSubmitModal"
                variant="success"
                :disabled="loading"
              >
                {{ $lang.ticketLang.send }}
                <i class="fa fa-check" />
              </b-button>
              <b-button
                class="ml-2"
                size="md"
                variant="danger"
                @click="closeModal"
              >
                {{ $lang.close }}
                <i class="fa fa-ban" />
              </b-button>
            </b-col>
          </b-row>
        </b-overlay>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/global/Button";
import TagComponent from "@/components/tag/tagComponent.vue";
import { required } from "vuelidate/lib/validators";
import { renderEumOptions, generateApiUrl } from "@/shared/utils";
import { pathOr, includes } from "ramda";

export default {
  name: "ticket-modal-buttons",
  inject: ["allTicketSmsRepository", "allTicketUnitRepository"],
  components: { Button, TagComponent },
  validations: {
    form: {
      ticket_unit_selected: { required },
      message_description: { required },
    },
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalTitle: null,
      modalMode: null,
      showModal: false,
      loading: false,
      form: {
        ticket_unit_selected: null,
        message_description: null,
        tag_selected: [],
      },
      tagInputRequired: true,
      tagCheckValidation: false,
    };
  },
  computed: {
    ticket_unit_options() {
      return renderEumOptions("ticket_unit");
    },
  },
  created() {
    this.form.tag_selected = pathOr([], ["tags"], this.item).map((tag) => {
      return {
        text: tag.caption,
        value: tag.id,
      };
    });
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    handleBack() {
      window.history.length > 1 ? this.$router.go(-1) : window.close();
    },
    closeModal() {
      this.$v.$reset();
      this.modalTitle = null;
      this.modalMode = null;
      this.showModal = false;
      this.form.message_description = null;
      this.form.ticket_unit_selected = null;
    },
    tagUpdateCheckValidation(data) {
      this.tagCheckValidation = data;
    },
    getSelected(data) {
      this.form.tag_selected = data;
    },
    handleSendSmsModal() {
      this.modalTitle = this.$lang.ticketLang.send_ticket_message;
      this.modalMode = "SEND_MESSAGE";
      this.showModal = true;
    },
    handleChangeUnitModal() {
      this.modalTitle = this.$lang.ticketLang.move_to_other_unit;
      this.modalMode = "TARGET_UNIT";
      this.showModal = true;
    },
    handleTagsModal() {
      this.modalTitle = this.$lang.ticketLang.edit_tags;
      this.modalMode = "SHOW_TAGS";
      this.showModal = true;
    },
    async sendSms() {
      this.$v.$touch();
      if (this.$v.form.message_description.$error || this.loading) return;
      try {
        this.loading = true;
        const payload = {
          description: this.form.message_description,
        };
        const response = await this.allTicketSmsRepository.create(
          this.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.handleBack();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async changeUnit() {
      this.$v.$touch();
      if (this.$v.form.ticket_unit_selected.$error || this.loading) return;
      try {
        this.loading = true;
        const payload = {
          ticket_unit_id: pathOr(
            null,
            ["value"],
            this.form.ticket_unit_selected
          ),
        };
        const response = await this.allTicketUnitRepository.partial_edit(
          this.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.handleBack();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async updateTags() {
      this.tagCheckValidation = true;
      if (
        (this.tagInputRequired && !this.form.tag_selected.length) ||
        this.loading
      )
        return;

      try {
        this.loading = true;
        const url = generateApiUrl(["resources", "tag"]);
        const payload = {
          resource: "ticket",
          key: this.id,
          tag_id: this.form.tag_selected.map((item) => item.value),
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.closeModal();
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    handleSubmitModal() {
      if (this.modalMode === "SEND_MESSAGE") this.sendSms();
      if (this.modalMode === "TARGET_UNIT") this.changeUnit();
      if (this.modalMode === "SHOW_TAGS") this.updateTags();
    },
  },
};
</script>